import { createCRUDConstants } from "../../../utils/redux.utils";

export const namespace = "SCPISSUERS"
export const issuerConstants = createCRUDConstants(namespace);

export const issuer_namespace = "POSTCARDISSUERS"
export const postCardIssuerConstants = createCRUDConstants(issuer_namespace);

export const card_programs_nameSpace = "ISSUERPROGRAMS";
export const cardProgramsConstants = createCRUDConstants(card_programs_nameSpace);

